import { useContext } from 'react';

import { UserAuthContext } from 'components/UserAuthManager';
import { userAuthStatusMap } from 'components/UserAuthManager/helpers';

/**
 * Determines if the current user is fully authenticated:
 *   * Signed in with an IdP
 *   * Matched with a DAD constituent record (NOT a first-time user)
 * @returns {boolean} bIsAuthenticated - Whether the user is authenticated
 */
const useIsUserAuthenticated = () => {
  const { userAuthStatus = userAuthStatusMap.loading } =
    useContext(UserAuthContext);

  switch (true) {
    case userAuthStatus === userAuthStatusMap.signedInMatched:
      return true;
    case userAuthStatus === userAuthStatusMap.signedInUnmatched:
    case userAuthStatus === userAuthStatusMap.notSignedIn:
      return false;
    case userAuthStatus === userAuthStatusMap.loading:
    default:
      return null;
  }
};

export default useIsUserAuthenticated;
